import { useParams } from "react-router";

// Plain helper for non-React contexts (route loaders, utilities) where a
// route param is structurally required by the route definition. Throws on
// undefined so a misnamed/missing param surfaces immediately instead of
// firing downstream queries with `undefined` values.
export const requireParam = (
  params: Record<string, string | undefined>,
  name: string,
): string => {
  const value = params[name];
  if (value === undefined) {
    throw new Error(`Required route param missing: ${name}`);
  }
  return value;
};

// React-component API. The throw bubbles to `<DashboardErrorBoundary>`
// (wired in `dashboard/route.tsx`) so a mistyped or renamed route renders
// an error UI instead of silently firing Apollo queries with `id: undefined`.
export const useRequiredParam = (name: string): string =>
  requireParam(useParams<Record<string, string | undefined>>(), name);
